import * as React from "react";
import type { SVGProps } from "react";
const SvgClock01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M15.284 15.349a1 1 0 0 0 .632-1.898l-.316.949zM12 13.2h-1a1 1 0 0 0 .684.949zm1-5.018a1 1 0 1 0-2 0h2m2.6 6.218.316-.949-3.6-1.2L12 13.2l-.316.949 3.6 1.2zM12 13.2h1V8.182h-2V13.2zm9.6-1.2h-1a8.6 8.6 0 0 1-8.6 8.6v2c5.854 0 10.6-4.746 10.6-10.6zM12 21.6v-1A8.6 8.6 0 0 1 3.4 12h-2c0 5.854 4.746 10.6 10.6 10.6zM2.4 12h1A8.6 8.6 0 0 1 12 3.4v-2C6.146 1.4 1.4 6.146 1.4 12zM12 2.4v1a8.6 8.6 0 0 1 8.6 8.6h2c0-5.854-4.746-10.6-10.6-10.6z"
    />
  </svg>
);
export default SvgClock01;
